import { useForm } from 'react-hook-form';
import { DefaultValuesType, FormBuilder, FormShape } from './types';
import getValidationSchema from './utils/getValidationSchema';

const useFastForm = (
	form: FormShape<FormBuilder>,
	defaultValues: DefaultValuesType,
) => {
	return useForm<DefaultValuesType>({
		defaultValues: defaultValues,
		mode: 'onBlur',
		reValidateMode: 'onChange',
		shouldFocusError: true,
		resolver: form && getValidationSchema(form),
	});
};
export default useFastForm;
